import React from 'react'
import './Footer.css'

const Footer = () => {
  return (
    <div className='footer'>
        <h3>&copy; Sofia Mäkiniemi 2024</h3>
    </div>
  )
}

export default Footer